var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      attrs: { dark: "", fixed: "", app: "" },
      model: {
        value: _vm.drawer,
        callback: function ($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer",
      },
    },
    [
      _c(
        "v-toolbar",
        { staticClass: "transparent" },
        [
          _c(
            "v-list",
            { staticClass: "p-0" },
            [
              _c(
                "v-list-item",
                {
                  staticClass: "home-header",
                  nativeOn: {
                    click: function ($event) {
                      return _vm.goToHome.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-list-item-avatar", [
                    _vm.schoolSetting && _vm.schoolSetting.imageUrl
                      ? _c("img", {
                          attrs: { src: _vm.schoolSetting.imageUrl },
                        })
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _vm.schoolSetting && _vm.schoolSetting.name
                        ? _c("v-list-item-title", [
                            _vm._v(_vm._s(_vm.schoolSetting.name)),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.user
        ? _c(
            "v-list",
            { staticClass: "pt-0 custom-links-v-list", attrs: { dense: "" } },
            [
              _vm.schoolSetting &&
              _vm.schoolSetting.useUserDashboard &&
              !_vm.user.isGuestExamOnly &&
              _vm.getVisiable("CLASSROOM_MENU_KBN_HOME")
                ? _c(
                    "v-list-item",
                    { attrs: { to: "/classroom", exact: true } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("home")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.schoolSetting.classroomMenus.find(
                                    function (item) {
                                      return (
                                        item.kbn == "CLASSROOM_MENU_KBN_HOME"
                                      )
                                    }
                                  ).viewName
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.schoolSetting &&
              _vm.schoolSetting.useGoal &&
              !_vm.user.isGuestExamOnly &&
              _vm.getVisiable("CLASSROOM_MENU_KBN_GOAL")
                ? _c(
                    "v-list-item",
                    { attrs: { to: "/classroom/user-goals" } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("api")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.schoolSetting.classroomMenus.find(
                                    function (item) {
                                      return (
                                        item.kbn == "CLASSROOM_MENU_KBN_GOAL"
                                      )
                                    }
                                  ).viewName
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.schoolSetting &&
              _vm.schoolSetting.useCourseLesson &&
              !_vm.user.isGuestExamOnly &&
              _vm.getVisiable("CLASSROOM_MENU_KBN_COURSE")
                ? _c(
                    "v-list-item",
                    { attrs: { to: "/classroom/my-courses" } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("tv")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.schoolSetting.classroomMenus.find(
                                    function (item) {
                                      return (
                                        item.kbn == "CLASSROOM_MENU_KBN_COURSE"
                                      )
                                    }
                                  ).viewName
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.schoolSetting &&
              _vm.schoolSetting.useExam &&
              _vm.getVisiable("CLASSROOM_MENU_KBN_TEST")
                ? _c(
                    "v-list-item",
                    { attrs: { to: "/classroom/my-exams" } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("explore")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.schoolSetting.classroomMenus.find(
                                    function (item) {
                                      return (
                                        item.kbn == "CLASSROOM_MENU_KBN_TEST"
                                      )
                                    }
                                  ).viewName
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.schoolSetting &&
              _vm.schoolSetting.useUserQuestion &&
              !_vm.user.isGuestExamOnly &&
              _vm.getVisiable("CLASSROOM_MENU_KBN_QUESTION")
                ? _c(
                    "v-list-item",
                    { attrs: { to: "/classroom/my-questions" } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("help_outline")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.schoolSetting.classroomMenus.find(
                                    function (item) {
                                      return (
                                        item.kbn ==
                                        "CLASSROOM_MENU_KBN_QUESTION"
                                      )
                                    }
                                  ).viewName
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.user.isGuestExamOnly &&
              _vm.getVisiable("CLASSROOM_MENU_KBN_ACTIVITY")
                ? _c(
                    "v-list-item",
                    { attrs: { to: "/classroom/activities" } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("search")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.schoolSetting.classroomMenus.find(
                                    function (item) {
                                      return (
                                        item.kbn ==
                                        "CLASSROOM_MENU_KBN_ACTIVITY"
                                      )
                                    }
                                  ).viewName
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.user.isGuestExamOnly &&
              _vm.getVisiable("CLASSROOM_MENU_KBN_INQUIRY")
                ? _c(
                    "v-list-item",
                    { attrs: { to: "/classroom/inquiries" } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("email")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.schoolSetting.classroomMenus.find(
                                    function (item) {
                                      return (
                                        item.kbn == "CLASSROOM_MENU_KBN_INQUIRY"
                                      )
                                    }
                                  ).viewName
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.user.isGuestExamOnly &&
              _vm.getVisiable("CLASSROOM_MENU_KBN_ANNOUNCEMENT")
                ? _c(
                    "v-list-item",
                    { attrs: { to: "/classroom/infors" } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("mdi-alert")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.schoolSetting.classroomMenus.find(
                                    function (item) {
                                      return (
                                        item.kbn ==
                                        "CLASSROOM_MENU_KBN_ANNOUNCEMENT"
                                      )
                                    }
                                  ).viewName
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.user &&
              _vm.user.isUseSubscription &&
              _vm.schoolSetting &&
              _vm.schoolSetting.usePremiumService &&
              _vm.user.subscriptions.length > 0 &&
              !_vm.user.isGuestExamOnly &&
              _vm.getVisiable("CLASSROOM_MENU_KBN_SUBSCRIPTION")
                ? _c(
                    "v-list-item",
                    { attrs: { to: "/classroom/subscription" } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("attach_money")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.schoolSetting.classroomMenus.find(
                                    function (item) {
                                      return (
                                        item.kbn ==
                                        "CLASSROOM_MENU_KBN_SUBSCRIPTION"
                                      )
                                    }
                                  ).viewName
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.getVisiable("CLASSROOM_MENU_KBN_MEETING") &&
              _vm.schoolSetting &&
              _vm.schoolSetting.useMeeting
                ? _c(
                    "v-list-group",
                    {
                      attrs: { value: _vm.$route.path.includes("appointment") },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-item-action",
                                  [_c("v-icon", [_vm._v("event")])],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(
                                        "\n              面談\n            "
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        4211166654
                      ),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        { attrs: { to: "/classroom/appointment#/dashboard" } },
                        [
                          _c("v-list-item-action"),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(
                                  "\n            ダッシュボード\n          "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          attrs: {
                            to: "/classroom/appointment#/teachers",
                            "exact-path": _vm.$route.hash.includes("teachers"),
                          },
                        },
                        [
                          _c("v-list-item-action"),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v("\n            先生を探す\n          "),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          attrs: {
                            to: "/classroom/appointment#/events",
                            "exact-path": _vm.$route.hash.includes("/events"),
                          },
                        },
                        [
                          _c("v-list-item-action"),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v("\n            予約一覧\n          "),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          attrs: {
                            to: "/classroom/appointment#/tickets",
                            "exact-path": _vm.$route.hash.includes("/tickets"),
                          },
                        },
                        [
                          _c("v-list-item-action"),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v(
                                  "\n            面談チケット\n          "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          attrs: {
                            to: "/classroom/appointment#/histories",
                            "exact-path":
                              _vm.$route.hash.includes("/histories"),
                          },
                        },
                        [
                          _c("v-list-item-action"),
                          _vm._v(" "),
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v("\n            過去の面談\n          "),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.getVisiable("CLASSROOM_MENU_KBN_LOGOUT")
                ? _c(
                    "v-list-item",
                    { on: { click: _vm.logout } },
                    [
                      _c(
                        "v-list-item-action",
                        [_c("v-icon", [_vm._v("logout")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.schoolSetting.classroomMenus.find(
                                    function (item) {
                                      return (
                                        item.kbn == "CLASSROOM_MENU_KBN_LOGOUT"
                                      )
                                    }
                                  ).viewName
                                ) +
                                "\n        "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }